module.exports = __webpack_public_path__ + "img/xls_dark.ebc35eb9.png";